import { HotspotExpandDirection, Size, Vector } from '@lessonup/pins-shared';
import { pinSize } from '../../foundations/layout/pinDefault';

const HALF_EDITOR_WIDTH = pinSize.width / 2;
const HALF_EDITOR_HEIGHT = pinSize.height / 2;

export const calculateFlipX = (
  expandDirection: HotspotExpandDirection,
  hotspotSize: Size,
  hotspotPosition: Vector
): boolean => {
  const isLeftExpand = ['LEFT_DOWN', 'LEFT_UP'].includes(expandDirection);
  return isLeftExpand || (expandDirection === 'AUTO' && hotspotPosition.x > HALF_EDITOR_WIDTH - hotspotSize.width / 2);
};

export const calculateFlipY = (
  expandDirection: HotspotExpandDirection,
  hotspotSize: Size,
  hotspotPosition: Vector
): boolean => {
  const isUpExpand = ['LEFT_UP', 'RIGHT_UP'].includes(expandDirection);
  return isUpExpand || (expandDirection === 'AUTO' && hotspotPosition.y > HALF_EDITOR_HEIGHT - hotspotSize.height / 2);
};

// The horizontal space between the hotspot and the content holder
const SPACE_BETWEEN = 8;

export const calculateContentHolderTranslateX = (isXFlipped: boolean, hotspotSize: Size): string => {
  if (isXFlipped) {
    return `calc(-100% - ${SPACE_BETWEEN}px)`;
  }
  return `${hotspotSize.width + SPACE_BETWEEN}px`;
};

export const calculateContentHolderTranslateY = (isYFlipped: boolean, hotspotSize: Size): string => {
  if (isYFlipped) {
    return `calc(-100% + ${hotspotSize.height}px)`;
  }
  return '0px';
};
